import styled from 'styled-components';
import { FlexDiv } from 'common/styles';
import { ButtonLadingContainer, BUTTON_PRIMARY } from 'components/TCButton/styles';
import { SIZE } from 'common/sizes';
import { COLOR_PALETTE } from 'common/colors';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const InLine = styled.div`
    display:flex;
    flex-flow: row;
    margin: 5px 0px 19px 0px;
    align-items: center;
`;

export const CheckContainer = styled.div`
    height: 9px;
    width: 9px;
    margin-right: 20px;
    margin-left: 15px;
    background-color: #112240;
    border-radius: 50%;
`;
